import { theme } from '@noths/polaris-client-ribbons-base';
import { pxToRem } from '@noths/polaris-client-styles';
import { css } from 'styled-components';

import * as styles from '../FieldWrapper/FieldWrapper.styles';

const { fonts } = theme;

const primaryRegularFont = css`
  font-family: ${fonts.PRIMARY_REGULAR.family};
  font-weight: ${fonts.PRIMARY_REGULAR.weight};
`;

export const input = styles.input;

export const inputWithPrefixSymbol = css`
  ${styles.input}

  padding-right: 8px;
  text-indent: 8px;
`;

export const visibilityButton = css`
  position: absolute;
  top: 0;
  right: 0;
  padding: ${pxToRem(theme.spacing.xs)};
  margin: ${pxToRem(theme.spacing.xs)};
  border-radius: ${pxToRem(5)};
  border: 0;
  background-color: transparent;
  cursor: pointer;
`;

export const prefixSymbol = css`
  position: absolute;
  top: 0;
  left: 0;
  padding: ${pxToRem(9)} 0 ${pxToRem(9)} ${pxToRem(12)};

  ${primaryRegularFont};
  ${theme.responsiveText.BODY.MD};
  color: var(--neutral-black-base);
`;
